import { getReferenceString } from '@medplum/core';
import { Patient } from '@medplum/fhirtypes';
import { useMemo } from 'react';

/**
 * Creates query variables for patient-based GraphQL queries
 * @param patient - Patient resource
 * @returns Query variables object with patientRef, or undefined if no patient
 */
export function usePatientQueryVariables(patient: Patient | undefined) {
  return useMemo(() => {
    if (!patient) return undefined;
    return {
      patientRef: getReferenceString(patient),
    };
  }, [patient]);
}
